import { render, staticRenderFns } from "./budget.vue?vue&type=template&id=fa16b358"
import script from "./budget.vue?vue&type=script&lang=js"
export * from "./budget.vue?vue&type=script&lang=js"
import style0 from "./budget.vue?vue&type=style&index=0&id=fa16b358&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports